import { render, staticRenderFns } from "./default-loader.vue?vue&type=template&id=f2443c10"
import script from "./default-loader.vue?vue&type=script&lang=js"
export * from "./default-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports